module.exports = __webpack_public_path__ + "static/placeholder-5a2e26c46ab7474094241567e785b763.jpg";